import { Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

export type ScheduleVisitInput = {
  customerUuid: Uuid;
  durationMinutes: number;
};

export const scheduleVisitInputSerializer = MSerializers.object<ScheduleVisitInput>({
  customerUuid: uuidSerializer,
  durationMinutes: MSerializers.integer,
});
